import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { isMobile } from 'utils/platform.utils';

const SafeAreaViewComponent = ({ children, ...props }) => {
  if (!isMobile()) {
    // Web/Desktop: plain passthrough — no safe-area logic needed.
    return (
      <Box sx={{ minHeight: '100dvh', width: '100%', ...props.sx }} {...props}>
        {children}
      </Box>
    );
  }

  return (
    /* ── Outer shell: fixed, fills entire screen including system bar areas ── */
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: '#13172a', // Restored previous background color
        overflow: 'hidden',         // Outer shell must NOT scroll
        ...props.sx,
      }}
      {...props}
    >
      {/* Top band: status bar / notch area.
          With overlaysWebView=true and contentInset="never", the WebView
          extends edge-to-edge. env(safe-area-inset-top) now returns the
          real notch / status-bar height on BOTH iOS and Android. */}
      <Box
        sx={{
          flexShrink: 0,
          width: '100%',
          height: 'env(safe-area-inset-top, 0px)',
          backgroundColor: '#000000',
        }}
      />

      {/* ── Scrollable content area ── */}
      <Box
        id="app-scroll-container"
        sx={{
          flex: '1 1 0',
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          // Prevent rubber-band bounce from showing black behind content
          overscrollBehaviorY: 'contain',
        }}
      >
        {children}
      </Box>

      {/* ── Bottom band: system navigation bar height, fixed black background ── */}
      <Box
        sx={{
          flexShrink: 0,
          width: '100%',
          height: 'env(safe-area-inset-bottom, 0px)',
          backgroundColor: '#000000',
        }}
      />
    </Box>
  );
};

SafeAreaViewComponent.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default SafeAreaViewComponent;
